import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import SectionLoadingcontainer from './sectionloadingcontainer';
import { updateAppState, updateComponentState } from '../actions/actions';
import { HorizontalBar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels'


const options = {
	maintainAspectRatio: false,
	tooltips: {
         enabled: false
    },
	plugins: {
		datalabels: { 
			display: true,
			color: '#212326',
			anchor:'center' 
		}
	},
	scales: {
		xAxes: [{
			barThickness : 15,
			stacked: true,
			gridLines: {
				display: false
			},
			ticks: {
				beginAtZero: false,
				precision: 0
			}
		}],
		yAxes: [{
			gridLines: {
				display: false
			}
		}]
	},
	responsive: true,
	legend: {
		display: false
	}
};

class Uptime extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uptime : [],
			fromdate : this.getDate('fromdate'),
			todate : this.getDate('todate'),
			uptimepercentage : null,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.getDate = this.getDate.bind(this);
		this.tileDate = this.tileDate.bind(this);
		this.tileOnClick = this.tileOnClick.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_height = document.getElementsByClassName('uptime_header') ? document.getElementsByClassName('uptime_header')[0].clientHeight : 0;
			table_header_height = 200 - table_header_height - 29;
			this.setState({ table_header_height });
		}, 300);
	}

	getDate(param){
		let tempObj = {
			fromdate : null,
			todate : null
		};
		if(this.props.app.companyid == 1 && ['Mumbai'].includes(this.props.app.branch) ){
			tempObj.fromdate = moment().startOf('quarter').toString();
			tempObj.todate = moment().endOf('quarter').toString();
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand' ){
			tempObj.fromdate = new Date('2023-08-28');
			tempObj.todate = new Date('2024-08-27');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tata' ){
			tempObj.fromdate = new Date('2023-05-13');
			tempObj.todate = new Date('2024-05-12');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh' ){
			tempObj.fromdate = new Date('2023-03-15');
			tempObj.todate = new Date('2024-03-14');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura' ){
			tempObj.fromdate = new Date('2021-12-23');
			tempObj.todate = new Date('2022-12-22');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New' ){
			tempObj.fromdate = new Date('2023-10-29');
			tempObj.todate = new Date('2024-10-28');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram' ){
			tempObj.fromdate = new Date('2023-06-01');
			tempObj.todate = new Date('2024-05-31');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland' ){
			tempObj.fromdate = new Date('2023-10-21');
			tempObj.todate = new Date('2024-10-20');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex' ){
			tempObj.fromdate = new Date('2023-12-01');
			tempObj.todate = new Date('2024-11-30');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Goa' ){
			tempObj.fromdate = new Date('2023-10-03');
			tempObj.todate = new Date('2024-10-02');
		}
		if(this.props.app.companyid == 1 && this.props.app.branch == 'BMC BLR' ){
			tempObj.fromdate = new Date('2024-10-01');
			tempObj.todate = new Date('2025-09-30');
		}
		if(this.props.app.companyid == 3){
			tempObj.fromdate = new Date('2024-11-18');
			tempObj.todate = new Date('2025-11-17');
		}
		if(this.props.app.companyid == 4){
			tempObj.fromdate = new Date('2023-09-01');
			tempObj.todate = new Date('2024-08-31');
		}
		if(this.props.app.companyid == 6){
			tempObj.fromdate = new Date('2024-12-01');
			tempObj.todate = new Date('2025-11-30');
		}
		if(this.props.app.companyid == 7){
			tempObj.fromdate = new Date('2025-02-15');
			tempObj.todate = new Date('2026-02-14');
		}
		if(this.props.app.companyid == 8){
			tempObj.fromdate = new Date('2025-04-01');
			tempObj.todate = new Date('2026-03-31');
		}
		if(this.props.app.companyid == 9){
			tempObj.fromdate = new Date('2025-05-15');
			tempObj.todate = new Date('2026-05-14');
		}

		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mumbai New'){
			let quarterObj = {
				'15/Jan/2024 to 14/Jan/2025' : {
					'Q1': '15/Jan/2024 to 14/Apr/2024','Q2': '15/Apr/2024 to 14/Jul/2024','Q3': '15/Jul/2024 to 14/Oct/2024','Q4': '15/Oct/2024 to 14/Jan/2025'
				},
				'15/Jan/2025 to 14/Jan/2026' : {
					'Q1': '15/Jan/2025 to 14/Apr/2025','Q2': '15/Apr/2025 to 14/Jul/2025','Q3': '15/Jul/2025 to 14/Oct/2025','Q4': '15/Oct/2025 to 14/Jan/2026'
				}
			};
			Object.keys(quarterObj).map((item)=>{
				let yearStart = item.split(' to ')[0];
				let yearEnd = item.split(' to ')[1];

				if(new Date() >= new Date(yearStart) && new Date() <= new Date(yearEnd)){
					let quarter = Object.keys(quarterObj[item]).find((key)=>{
						let startDate = quarterObj[item][key].split(' to ')[0];
						let endDate = quarterObj[item][key].split(' to ')[1];
						if(new Date() >= new Date(startDate) && new Date() <= new Date(endDate)) return key;
					});
					tempObj.fromdate = moment(quarterObj[item][quarter].split(' to ')[0],'DD/MMM/YYYY').toString();
					tempObj.todate = moment(quarterObj[item][quarter].split(' to ')[1],'DD/MMM/YYYY').toString();
				}
			});
		}

		return tempObj[param];
	}

	tileDate(){
		let tempDate = null;
		if(this.props.app.companyid == 1 && ['Mumbai'].includes(this.props.app.branch)) tempDate = `${moment().format('YYYY')} Q${moment().format('Q')}`;
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand') tempDate = '28 Aug 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tata') tempDate = '13 May 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh') tempDate = '15 Mar 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura') tempDate = '23 Dec 2021 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New') tempDate = '29 Oct 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram') tempDate = '01 Jun 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland') tempDate = '21 Oct 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Goa') tempDate = '03 Oct 2023 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'BMC BLR') tempDate = '01 Oct 2024 to Date';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex') tempDate = '01 Dec 2023 to Date';
		if(this.props.app.companyid == 3) tempDate = '18 Nov 2024 to Date'
		if(this.props.app.companyid == 4) tempDate = '01 Sep 2023 to Date'
		if(this.props.app.companyid == 6) tempDate = '01 Dec 2024 to Date';
		if(this.props.app.companyid == 7) tempDate = '15 Feb 2025 to Date';
		if(this.props.app.companyid == 8) tempDate = '01 Apr 2025 to Date';
		if (this.props.app.branch == 'Mumbai New'){
			let quarterObj = {
				'15/Jan/2024 to 14/Jan/2025' : {
					'Q1': '15/Jan/2024 to 14/Apr/2024','Q2': '15/Apr/2024 to 14/Jul/2024','Q3': '15/Jul/2024 to 14/Oct/2024','Q4': '15/Oct/2024 to 14/Jan/2025'
				},
				'15/Jan/2025 to 14/Jan/2026' : {
					'Q1': '15/Jan/2025 to 14/Apr/2025','Q2': '15/Apr/2025 to 14/Jul/2025','Q3': '15/Jul/2025 to 14/Oct/2025','Q4': '15/Oct/2025 to 14/Jan/2026'
				}
			};
			Object.keys(quarterObj).map((year)=>{
				let yearStart = year.split(' to ')[0];
				let yearEnd = year.split(' to ')[1];
				if(new Date('2025-01-10') >= new Date(yearStart) && new Date('2025-01-10') <= new Date(yearEnd)){
					Object.keys(quarterObj[year]).forEach((quarter)=>{
						let startDate = quarterObj[year][quarter].split(' to ')[0];
						let endDate = quarterObj[year][quarter].split(' to ')[1];

						if(new Date() >= new Date(startDate) && new Date() <= new Date(endDate)){
							tempDate = `${moment(new Date(startDate)).format('MMM DD')} - ${moment(new Date(endDate)).format('MMM DD')} - ${quarter}`;
						}
					});
				}
			});
		}

		return tempDate;
	}

	onload(){
  		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			axios.get(`/api/uptime?pagetype=widget&fromdate=${new Date(this.state.fromdate).toDateString()}&todate=${new Date(this.state.todate).toDateString()}`).then((response) => {
				if (response.data.message == 'success') {
					
					let uptime = [] ,uptimepercentage=null, totaluptime = null , totalactualtime = null;
					if(response.data.main && response.data.main.length > 0){
						response.data.main.forEach((item)=>{
							totaluptime += item.uptimetime;
							totalactualtime += item.actualtime;
						});
						uptimepercentage = Number(((totaluptime * 100)/totalactualtime).toFixed(2)); 
						uptime = response.data.main;
					}
				
					this.setState({
						uptime,
						uptimepercentage,
						loaderflag : false
					});
					this.props.updateComponentState(this.props.form,{
						uptime,
						uptimepercentage,
						loaderflag : false,
						fromdate : this.state.fromdate,
						todate : this.state.todate
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	tileOnClick(){
		let tempObj ={
			fromdate : this.state.fromdate,
			todate : this.state.todate
		};

		if((this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7) this.props.history.push("/uptimebygroup");
		else if (this.props.app.companyid == 8) this.props.history.push({pathname: `/uptimebyhospital/null`, params: {groupid: null,territoryid:null}});
		else if(this.props.app.companyid == 6 || (this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch))) this.props.history.push("/uptimebystate");
		else this.props.history.push("/uptimebydistrict");
	}

	renderChart(){
		let chartData = {
		  labels: ['Actual', 'Goal'],
		  datasets: [
		    {
		      label: 'Uptime',
		      backgroundColor: ["#1DDDA0","#798FFF"],
		      data: [this.state.uptimepercentage,95]
		    }
		  ]
		};
		
		return (
			<div>
				<HorizontalBar data={chartData} options={options}  width={140} height={100}/>
			</div>
        );
	}

	render() {
		let { uptime, uptimepercentage } = this.state;
		return (
			<div className="row no-gutters h-100" onClick={()=>{this.tileOnClick();}}>
				<div className="col-md-12">
					<SectionLoadingcontainer isloading={this.state.loaderflag}></SectionLoadingcontainer>
					<div className="row">
						<div className="col-md-12 section-header uptime_header">
							<div className="section-header-title" style={{float:'left',color: "#008060"}}>Uptime</div>
							<div className="section-count-small" style={{float:'right',color: "#405FFF",display : "flex"}}><img style={{marginRight : "10px" }} src='/images/widget_icon_uptime.svg'/> {uptimepercentage}</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md-12">
							<div className="gs-scrollbar" style={{overflow: 'auto', height: `${this.state.table_header_height}px`}}>
								{uptime.length > 0 ? <table className="table dashboardwidget">
									<thead>
										<tr>
											<th></th>
											<th className="text-center table-content">Goal</th>
											<th className="text-center table-content">Actual</th>
										</tr>
									</thead>
									<tbody>
										{uptime.map((item, key) => {
											return <tr key={key}>
												<td className="text-left table-content">{item.group}</td>
												<td className="text-center table-body-count-small">{item.goalpercentage}%</td>
												<td className="text-center table-body-count-small">{item.uptimepercentage}%</td>
											</tr>
										})}
									</tbody>
								</table> : null}
							</div>
						</div>
					</div>
					{
						(!this.props.app.isDemoDashboard) ?
							<div className="row" style={{float: "right",bottom: "0px",color: "#FC786F",position:"absolute",right: "0px"}}>	
								<div className="col-md-12 table-content-small">
									{this.tileDate()}
								</div>
							</div>
						: null
					}
				</div>
			</div>
		);
	}
}

Uptime = connect(
	(state, props) => {
		let formName = 'uptime';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState, updateComponentState }
)(reduxForm()(Uptime));

export default Uptime;


// WEBPACK FOOTER //
// ./public/react/components/uptime.js